// extracted by mini-css-extract-plugin
module.exports = {"selectedPlaceholder":"Select_selectedPlaceholder__BHvC4","selected":"Select_selected__3O8jO"};